import React from 'react';
import { Modal, Text, Crate } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { getPaymentCopy } from '../../../../payment-methods.utils';
import { PlanToggles } from '../../../plan-toggles';

const getCopy = copyFor(
  'settings.paymentInformation.addPaymentMethodModal.screens.setPaymentMethod'
);

interface SendProps {
  type: string;
  data: {
    mutationVariablesForSetPayment?: MutationVariablesForSetPayment;
  };
}
interface Props {
  context: AddPaymentMethodContext;
  next: () => void;
  close: () => void;
  send: (props: SendProps) => void;
}

export const SetPaymentMethod = ({ context, next, close, send }: Props) => {
  const { accountId, activePlans, newPaymentMethod, isActivePlanWhale } =
    context;
  if (!accountId || !activePlans || !newPaymentMethod) return null;

  const { label, text } = getPaymentCopy({
    paymentMethod: newPaymentMethod,
    labelProps: { textStyle: 'heading700' },
  });
  return (
    <>
      <Modal.Header title={getCopy('title')} onClose={close} />
      <Modal.Content>
        <Crate
          border={{ bottom: { width: '1px', color: 'tertiary' } }}
          padding={{ bottom: '21px' }}
        >
          {label}
          {text}
        </Crate>
        <Text textStyle="heading500" margin={{ bottom: '32px', top: '24px' }}>
          {getCopy('subtitle')}
        </Text>
        <PlanToggles
          accountId={accountId}
          plans={activePlans}
          setMutationVariables={mutationVariablesForSetPayment =>
            send({
              type: 'toggleChange',
              data: { mutationVariablesForSetPayment },
            })
          }
          isActivePlanWhale={!!isActivePlanWhale}
          paymentMethodId={newPaymentMethod.id}
        />
        <Text textStyle="paragraph400" color="secondary">
          {getCopy('note')}
        </Text>
      </Modal.Content>
      <Modal.Footer
        onSubmit={() => next()}
        primaryText={getCopy('buttons.submit')}
      />
    </>
  );
};
